import { useWindowSize } from "../effects/useWindowSize";
import CloseIconBig from "../icons/CloseIconBig";
import BadgeIcon from "./BadgeIcon";
import './PetTooltip.scss';
import Tooltip from "./Tooltip";


const PetTooltip = ({ title, text, iconName, children }) => {
    const windowSize = useWindowSize();

    var tooltipContent = (
        <div className="PetTooltip">
            <div className="PetTooltip__title">
                <BadgeIcon name={iconName} />{title}
                {windowSize.width < 768 ? <button className="PetTooltip__close"><CloseIconBig /></button> : null}
            </div>
            {/* <div className="PetTooltip__content">{text}</div> */}
        </div>
    );
    return (
        <Tooltip trigger={"hover"} title={tooltipContent}>
            {children}
        </Tooltip>
    );
};

export default PetTooltip;